import { getFont, getMargins } from '@24i/nxg-sdk-higgs';
import { isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';
import { Theme } from '@24i/nxg-sdk-photon';

import { SeeAllScreenStyles } from './types';

const seeAllStyles = (theme: Theme): SeeAllScreenStyles => ({
    holder: {
        backgroundColor: theme.color.background1,
        flex: 1,
        flexDirection: 'column',
        ...getMargins(),
    },
    pickerHolder: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: theme.color.background1,
        marginTop: 96,
        ...(isWebMobile() && {
            marginTop: 20,
        }),
    },
    sectionTitle: {
        textAlign: isWebMobile() ? 'center' : 'left',
        ...getFont(theme, 'h2'),
        color: theme?.color?.textPrimary,
        width: '100%', // Ensure full width
        justifyContent: isWebMobile() ? 'center' : 'flex-start', // Center horizontally on mobile, left on desktop
        alignSelf: isWebMobile() ? 'center' : 'flex-start', // Center self on mobile, left on desktop
    },
});

export default seeAllStyles;
